module.exports = __webpack_public_path__ + "static/media/support.5752f404.gif";